import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link, browserHistory } from 'react-router';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { DeleteModal } from '../../../technicalInspection/Elements';
import { CtrTableHd, ContractSideBar, Header, ContractBarLoader, EditSidebar } from '../../Elements';
import { InfoIcon, ListLoader } from '../../../../shared';
import { invoiceViewAc, InvoiceAssetViewAc, changeInvoiceStatusAc, detailInvExportAc, getShareInvoiceInfoAc, updateShareInvFnAc, deleteInvoiceViewAc } from '../actionCreators';
import { sExportContractsAc } from '../../../../shared/actionCreators';
import { INVOICE_SHARE } from '../actions';
import InvFields from '../components/InvFields';
import ChangeInvoiceStatus from '../components/ChangeInvoiceStatus';
import ShareInvoice from '../components/ShareInvoice';
import { invoiceStatusList, displayDateFormat, invoiceDescList, imgStoragePath, assetsType, backendDateFormat, displayDateTimeFormatShort, assetId } from '../../../../constants';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import { getLocalStorageInfo, showCurrencyFormat } from '../../../../utils';
import { checkApiStatus, checkPermission, downloadFile, toastFlashMessage } from '../../../../utils_v2';
import InvoiceInfo from '../components/InvoiceInfo'
import LessorInfo from '../components/LessorInfo'
import LesseeInfo from '../components/LesseeInfo'
import BankingInfo from '../components/BankingInfo'
import MaintenanceInvoiceItem from '../components/MaintenanceInvoiceItem'
import RentalInvoiceItem from '../components/RentalInvoiceItem'
import CreditDebitNote from '../components/CreditDebitNote'
import PenaltyInvoiceItem from '../components/PenaltyInvoiceItem'
import SecurityInvoiceItem from '../components/SecurityInvoiceItem'
import InsuranceInvoiceItem from '../components/InsuranceInvoiceItem'
import MRAdhocInvoiceItem from '../components/MRAdhocInvoiceItem'
import RentalAdhocInvoiceItem from '../components/RentalAdhocInvoiceItem'
import editIcon from '../../../../shared/assets/img/edit_icon.svg';
import exportIcon from '../../../../shared/assets/img/export_icon.svg';
import emailIcon from '../../../../shared/assets/img/send_email_icon.svg';
import PartialPaymentsList from '../components/PartialPaymentsList';
import { getInvoiceStatusTimelineApi, getThirdPartyAppUrl } from '../apiServices';
import HorizontalTimeline from "react-horizontal-timeline";
import { Dialog, DialogContent, DialogTitle, Paper, Tooltip, Typography, Button as MuiButton, Grid, TextField, DialogActions, CircularProgress, Stepper, Step, StepLabel, StepConnector, TableContainer, TableHead, TableRow, TableCell, TableBody, Table } from '@material-ui/core';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { Autocomplete, TimelineOppositeContent } from '@material-ui/lab';
import { contrHdlineInfoAc } from '../../HeadlinesInfo/actionCreators';
import { Close, Info, KeyboardArrowDown ,InfoOutlined } from '@material-ui/icons';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import { gaTelesisInstance, hanwahaInstance, Lessor_test, testLessor, titanInstance } from '../../../../shared_elements/components';
import appConfig from '../../../../config';
import { globalGetService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { globalPutService } from '../../../../globalServices';
import ManagementFee from '../components/ManagementFee';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { DropzoneArea } from 'material-ui-dropzone';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import FilePreview from '../../../../shared_elements/components/FilePreview';
import { EmptyCollection, PageLoader } from '../../../../shared_elements';
import { jetStreamInstance } from '../../../../lease_management/Leases';
import revisionHistoryIcon from '../../../../shared/assets/img/revision_history_icon.svg';
import ApprovalTimelineModal from '../components/ApprovalTimelineModal';
import RejectedStatusChangeModal from '../components/RejectedStatusChangeModal';
import UtilsAttachments from '../components/UtilsAttachments';
class ViewInvoiceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      delModal: false,
      deleteInvoice: false,
      dropdownOpen: false,
      data: {},
      statusTimeline: [],
      showStatusTimeLine: false,
      thirdPartyAppUrl: '',
      loader: false,
      syncAgainFlag:null,
      approverInfo:[],
      approverModal:false,
      approver:[],
      formData:{working_group_id: null,remark:'',next_stage_working_group_id: null,rejected_stage_working_group:null},
      error:{},
      approverLoader:false,
      loadingButton: null,
      approvalDetailsLoaded : false,
      attatchedDoc:null,
      attachments:[],
      attachmentModalOpen: false,
      filePreviewModal:false,
      selectedFile:null,
      showNextApprover:false,
      prevApprover:false,
      timelineModal:false,
      rejectedModal:false,
      isRejectSave : false
    };
    this.toggle = this.toggle.bind(this);
    this.getInvoiceStatusTimelineApi = getInvoiceStatusTimelineApi.bind(this);
    this.getThirdPartyAppUrl = getThirdPartyAppUrl.bind(this);
  }
  componentDidMount() {
    this.props.fetchContractInfo();
    this.props.fetchAssetInfo();
    this.props.fetchInvoiceView();
    this.getInvoiceStatusTimelineApi(this.props)
    this.getApprovalDetails()
    this.fetchApprovers()
    this.getAttachments()
  }

  fetchApprovers = () => {
    const { contract_slug } = this.props.params;
    globalGetService(`contracts/${contract_slug}/working-group-master-list/?is_active_member=true`, {})
      .then((response) => {
        if (response?.data?.data) {
          this.setState({ approver: response.data.data });
        }
      })
  };

  getApprovalDetails = () => {
      const { contract_slug } = this.props.params;   
      globalGetService(`/contracts/${contract_slug}/invoices/${this.props.params.id}/invoice-approval-details/`, {})
        .then((response) => {
          if (response?.data?.data) {
            this.setState({ approverInfo: response.data.data,approverLoader:this.state?.attatchedDoc?.length?true:false });
            this.setState({ approvalDetailsLoaded: response?.data?.data.approval_status?.is_invoice_approval===true ?true:false });
          }else{
              this.setState({ approverLoader:false });
          }
        })
  }
    getAttachments = () => {
      const { contract_slug } = this.props.params;   
      globalGetService(`/contracts/${contract_slug}/invoices/${this.props.params.id}/attachments/?model_type=26`)
        .then((response) => {
          if (response?.data) {
            this.setState({ attachments: response?.data?.list?.data });
          }
        })
  }
    addApproverAttachment = (data, invoiceStatus=false) => {
      const { props, params } = this.props;
      const { attatchedDoc, returnCond,loader } = this.state;
      let formdata = new FormData();
      attatchedDoc.forEach(item => {
        formdata.append('files', item);
      });
      formdata.append('asset_type', assetId[params?.type])
      formdata.append('asset_slug', params.aircraft_slug)
      formdata.append('contract_slug', params.contract_slug)
      formdata.append('model_type', '26');
      formdata.append('object_id', data?.id)
      this.setState({ approverLoader: true});
      globalPostService(`contracts/attachments/`, formdata)
        .then(response => {
          if (response?.data.statusCode === 200) {
            if (invoiceStatus === true) {
              this.props.updateInvStatus({ paid_date: moment().format(backendDateFormat), status: 2, status_change_reason: "", }, 'view');
            }
            toastFlashMessage(response.data.message, 'success')
            this.getAttachments()
          } else {
            toastFlashMessage(response.data.message, 'error')
            if (invoiceStatus === true) {
              this.props.updateInvStatus({ paid_date: moment().format(backendDateFormat), status: 2, status_change_reason: "", }, 'view');
            }
          }
         this.setState({ approverLoader: false, attatchedDoc: []});          
        });
    }
  getStageName = (stage) => {
      switch (stage) {
        case 1: return "Finance Control";
        case 2: return "Accounting Control";
        case 3: return "Final Control";
        default: return "";
      }
    };

  updateApprovalStatus = (status, invoiceStatus, loadingKey = null) => {
    const { contract_slug } = this.props.params;
    const { approverInfo } = this.state
    const {invoiceInfo} = this.props 
    const currentStage = approverInfo?.approval_details?.[0]?.stage || 1;
    const nextStage =!titanInstance? currentStage : approverInfo?.approval_details?.[0]?.status === "approved" ? currentStage + 1 : approverInfo?.approval_details?.[0]?.status === "reject" && invoiceInfo.is_reserve_releted ? currentStage-1 : currentStage;
    const nameStage = approverInfo?.approval_details?.[0]?.status === "approved" ? currentStage + 1 :approverInfo?.approval_details?.[0]?.status === "reject" && approverInfo.approval_status.current_stage===2 ? approverInfo.approval_status.current_stage : approverInfo?.approval_details?.[0]?.status === "reject" ?  currentStage+1 : currentStage;
    const nextStageName = this.getStageName(approverInfo?.approval_status?.status === "pending" && nameStage+1 !==4 && loadingKey==='approve'  ? nameStage+1 : nameStage-1);
    const next_stage_working_group_id = approverInfo?.working_group_config?.[nextStageName]?.id || null;
    const isStageOne = titanInstance && approverInfo?.approval_status?.approval_status_code === 1 && !approverInfo?.approval_status?.working_group_id && approverInfo?.approval_status?.current_stage === 1;
    const defaultApprover = isStageOne ? this.state.approver.find(a => a.name === "Finance Control") : null;
    let validationInputs = {
      remark: status === 4 ? this.state.formData?.remark.length  ? '' : 'Please Enter Reason' : '',
      working_group_id:  ((titanInstance && currentStage!==3 ? [1,4,3].includes(approverInfo?.approval_status?.approval_status_code):[1,4].includes(approverInfo?.approval_status?.approval_status_code)) ? this.state.formData?.working_group_id||defaultApprover?.id:approverInfo?.approval_status?.working_group_id||defaultApprover?.id) ? '' : 'Please Select Approval Group',
      next_stage_working_group_id :titanInstance && (loadingKey === 'approve'&& approverInfo?.approval_status?.current_stage !== 3 || loadingKey === 'reject'&& approverInfo?.approval_status?.current_stage !== 1 )&& !(next_stage_working_group_id||this.state.formData?.next_stage_working_group_id) && (invoiceInfo.invoice_type===1 || invoiceInfo.parent_invoice_type===1 || invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true ) ? 'Please Select Approval Group':'',
      rejected_stage_working_group : loadingKey === 'reject' && titanInstance && this.state.isRejectSave && invoiceInfo?.is_reserve_releted && approverInfo?.approval_status?.current_stage ===3 && !this.state.formData.rejected_stage_working_group ? "Please Select Rejected To": ""
    }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      let payload = {
        working_group: this.state.formData.working_group_id ? this.state.formData.working_group_id :defaultApprover?defaultApprover?.id: null,
        stage:nextStage
      }
      let statusPayload = {
        working_group: approverInfo?.approval_status?.working_group_id||defaultApprover,
        status: status,
        stage:nextStage,
        remark: this.state.formData?.remark || '',
        is_attachment: this.state?.attatchedDoc?.length ? true : false,
        next_stage_working_group_id:this.state.formData?.next_stage_working_group_id ?this.state.formData?.next_stage_working_group_id?.id: next_stage_working_group_id,
        ...((invoiceStatus === true && titanInstance)?{send_and_approved:true}:{})
      }
      const rejectWorkingGroupStagePayload ={
        ...statusPayload,
        next_stage_working_group_id : this.state.formData?.rejected_stage_working_group ? this.state.formData?.rejected_stage_working_group?.id :null,
        next_stage : this.state.formData?.rejected_stage_working_group ? this.state.formData?.rejected_stage_working_group?.stageIndex :null,
      }
      if (loadingKey === 'reject' && titanInstance && !this.state.isRejectSave && invoiceInfo?.is_reserve_releted && approverInfo?.approval_status?.current_stage ===3) {
        this.setState({ rejectedModal: true , isRejectSave :true });
        return; 
      }
    this.setState({ approverLoader: true, loadingButton: loadingKey });
      globalPostService(status?`/contracts/${contract_slug}/invoices/${this.props.params.id}/invoice-approval-details/`:`/contracts/${contract_slug}/invoices/${this.props.params.id}/send-approval-email/`, status!=="" ?  loadingKey === 'reject' && titanInstance && this.state.isRejectSave && invoiceInfo?.is_reserve_releted && approverInfo?.approval_status?.current_stage ===3 ? rejectWorkingGroupStagePayload : statusPayload : payload)
        .then((response) => {
          if (checkApiStatus(response)) {
            this.setState({ approverLoader: false, loadingButton: null, approverModal: !this.state.approverModal,isRejectSave:false,loadingKey :null,rejectedModal:false, formData: { working_group_id: null, remark: '', next_stage_working_group_id: null, }, error: {}, showNextApprover:false, prevApprover:false,rejected_stage_working_group:null });            
            this.getApprovalDetails()
            
            if (invoiceStatus === true && !this.state?.attatchedDoc?.length) {
              this.props.updateInvStatus({ paid_date: moment().format(backendDateFormat), status: 2, status_change_reason: "" }, 'view')
            }
            if(titanInstance && invoiceInfo?.is_reserve_releted === true && approverInfo?.approval_status?.current_stage=== 3){
              this.props.fetchInvoiceView();
            }
            if (this.state?.attatchedDoc?.length) {
              this.addApproverAttachment(response.data.data, invoiceStatus)
            }
            toastFlashMessage(response?.data?.message, 'success');
          } else {
            this.setState({ approverLoader: false, loadingButton: null });
            toastFlashMessage(response?.data?.message, 'error');
          }
        })
    } else {
      this.setState({ error: validationInputs });
    }
  }

  onRejectSave = () => {
     this.updateApprovalStatus(4, false, 'reject')
  };

  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }


  toggleDelModal(data) {
    this.setState({
      delModal: !this.state.delModal,
      data: data,
    });
  }

  toggleExport = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  changeMsn = (evt) => {
    let url = '/' + assetsType[evt.asset_type] + '/' + evt.slug + '/contracts';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  updateInvStatus = (data) => {
    this.toggle();
    if (data.status == 3 || data.status == 4) {
      this.toggleDelModal(data);
    } else {
      this.props.updateInvStatus(data, 'view');
    }
  }
  getThirdPartyFn =(data)=>{
    const {invoiceInfo} = this.props 
    if(invoiceInfo?.qb_last_sync_by?.name && invoiceInfo?.qb_last_sync_time){
      this.setState({syncAgainFlag:{flag:true, data:data}})
    }
    else{
      this.getThirdPartyAppUrl(data)
    }
  }
  getHours = (units, unit_type, invoice_item_type) => { return units.toString() }
  
  updateApprover = (field, value) => {
    if(field==='working_group_id'){
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value ? value.id : null
      }
    }))
  }else{
        this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value ? value: ''
      }
    }))
  }
  } 
  handleViewClick = (item) => {
  this.setState({
    selectedFile: item,
    filePreviewModal: true, 
  });
};
 TotalOffset =(data)=>{
  return(
    (data?.invoiceInfo?.offset_invoice_details?.credit_offset_amount || data?.invoiceInfo?.offset_invoice_details?.debit_offset_amount) ?
    <>
     {data.invoiceInfo?.offset_invoice_details?.credit_offset_amount? <h5 className="para-ui">Credit Offset Amount :
        -<NumericLabel params={showCurrencyFormat(data?.invoiceInfo.currency)}>
          {data.invoiceInfo?.offset_invoice_details?.credit_offset_amount || 0}
        </NumericLabel>
      </h5>:null}
      {data.invoiceInfo?.offset_invoice_details?.debit_offset_amount?
      <h5 className="para-ui">Debit Offset Amount :
        <NumericLabel params={showCurrencyFormat(data?.invoiceInfo.currency)}>
          {data.invoiceInfo?.offset_invoice_details?.debit_offset_amount || 0}
        </NumericLabel>
      </h5>:null}
    </>:null
  )
}
 GrandTotal =(data)=>{
    const { invoiceInfo } = this.props;
     const total = invoiceInfo && invoiceInfo.invoice_items ? (invoiceInfo.invoice_items.reduce((total, next) => total + next.billable_amount, 0) + invoiceInfo.invoice_items.reduce((total, next) => total + next.tax_amount, 0)) : 0
    const partialPaidAmount = invoiceInfo && invoiceInfo.partial_paid_amount ? invoiceInfo.partial_paid_amount : 0
    const diff = total - partialPaidAmount;
  return(
    data?.invoiceInfo?.status == 3 && (data?.invoiceInfo?.offset_invoice_details?.debit_offset_amount || data?.invoiceInfo?.offset_invoice_details?.credit_offset_amount)?
      <h4 className="para" style={{marginTop:"2px"}}> Grand Total Amount :
        <NumericLabel params={showCurrencyFormat(data?.invoiceInfo.currency)}>
          {total + parseFloat(data?.invoiceInfo?.offset_invoice_details?.debit_offset_amount || 0)-parseFloat(data?.invoiceInfo?.offset_invoice_details?.credit_offset_amount || 0)} 
        </NumericLabel>
      </h4>:
       data?.invoiceInfo?.status == 5?
      <h4 className="para" style={{marginTop:"2px"}}> Remaining Amount :
        <NumericLabel params={showCurrencyFormat(data?.invoiceInfo.currency)}>
          {diff}
        </NumericLabel>
      </h4>:null
  )
}
  render() {
    const { invoiceInfo, ctrShortInfo, params, invoiceLoader, shareInvoiceCrud, invoiceExportLoader, contractInfo } = this.props;
    const startDate = invoiceInfo && invoiceInfo.start_date ? invoiceInfo.start_date : null
    const endDate = invoiceInfo && invoiceInfo.contract_end_date ? invoiceInfo.contract_end_date : null
    const total = invoiceInfo && invoiceInfo.invoice_items ? (invoiceInfo.invoice_items.reduce((total, next) => total + next.billable_amount, 0) + invoiceInfo.invoice_items.reduce((total, next) => total + next.tax_amount, 0)) : 0
    const partialPaidAmount = invoiceInfo && invoiceInfo.partial_paid_amount ? invoiceInfo.partial_paid_amount : 0
    const diff = total - partialPaidAmount;
    const totalExcessAmounts = invoiceInfo.invoice_items?.reduce((acc, item) => acc + parseFloat(item.excess_amount || 0), 0);
    const { showStatusTimeLine, statusTimeline , approverModal, approverInfo, error, approverLoader, loadingButton} = this.state
    let isJac = getLocalStorageInfo().defaultLessor.id === 442 ? true : false
    const invoiceDate = moment(invoiceInfo?.created_at); 
    const newInvoiveDate = appConfig.env.key === "api" ? moment('2025-06-08T00:00:00') : moment('2025-05-26T10:00:00')
    const JctDiff = (total+invoiceInfo.invoice_items?.reduce((total, next) => total + parseFloat(parseFloat(next.sub_total).toFixed(2)), 0)/10) - partialPaidAmount
    const getLatestForStage = (stageId) => {
      if (!approverInfo?.approval_details) return null;
      return approverInfo.approval_details.reduce((latest, current) => {
        if (current.stage !== stageId) return latest;
        return !latest || current.id > latest.id ? current : latest;
      }, null);
    };
    const stages = [1, 2, 3].map(stageId => getLatestForStage(stageId));
    let activeStage = 0;
    const rejectedStageIndex = stages.findIndex(stage => stage?.status === "reject");
    if (rejectedStageIndex !== -1) {
      activeStage = rejectedStageIndex === 0 ? 0 : rejectedStageIndex - 1;
    } else {
      activeStage = stages.findIndex(stage => stage?.status === "pending");

      if (activeStage === -1) {
        activeStage = stages.map(stage => stage?.status).lastIndexOf("approved");
      }

      if (activeStage < 0) activeStage = 0;
    }

    const getDisplayStage = (approval_status) => {
      let stage = approval_status?.current_stage;
      if (approval_status?.is_rejected) {
        return approval_status?.current_stage;
      }
      if (
        approval_status?.approval_status_code === 3 &&
        approval_status?.status === "approved" &&
        approval_status?.is_rejected === false
      ) {
        stage = Math.min(stage + 1, 3);
      }
      return stage;
    };

    const getStageName = (stage) => {
      switch (stage) {
        case 1: return "Finance Control";
        case 2: return "Accounting Control";
        case 3: return "Final Control";
        default: return "";
      }
    };
    const effectiveStage = approverInfo?.approval_status?.is_rejected && approverInfo?.approval_status?.current_stage === 3 ? 2 : approverInfo?.approval_status?.is_rejected && approverInfo?.approval_status?.current_stage === 2 ? 1 : approverInfo?.approval_status?.current_stage === 1 && approverInfo?.approval_status?.approval_status_code === 2?0:  approverInfo?.approval_status?.current_stage;
    const displayStage = getDisplayStage(approverInfo?.approval_status);
    const lastCreatedById = approverInfo?.approval_details?.length ? approverInfo?.approval_details[approverInfo?.approval_details?.length - 1]?.created_by?.id : null;
    const currentStage = approverInfo?.approval_details?.[0]?.stage || 1;
    const nameStage = approverInfo?.approval_details?.[0]?.status === "approved" ? currentStage + 1 : approverInfo?.approval_details?.[0]?.status === "reject" ? currentStage+1 : currentStage;
    const nextStageName = this.getStageName(approverInfo?.approval_details?.[0]?.status === "pending" && nameStage+1 !==4  ? nameStage+1 : nameStage-1);
    const next_stage_working_group_id = approverInfo?.working_group_config?.[nextStageName]?.id || null;
    const isStageOne = approverInfo?.approval_status?.approval_status_code === 1 && approverInfo?.approval_status?.current_stage === 1;
    const defaultApprover = isStageOne && (invoiceInfo?.invoice_type === 1 || invoiceInfo?.is_reserve_releted === true || invoiceInfo?.parent_invoice_type === 1) && titanInstance ? this.state.approver.find(a => a.name === "Finance Control") : null;
    return (
      <div className="mr-rate-wrapper  mr-rate-spacing" >
        <Header type="brief" headingText="Lease Management" params={this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
        {
          invoiceInfo && Object.keys(invoiceInfo).length ?
            <ContractSideBar application={`Invoice View - ${invoiceInfo.invoice_number}`} type="brief" params={this.props.params} />
            : null
        }
        {invoiceLoader || this.state.loader ? <ListLoader /> : null}
        {invoiceExportLoader  || this?.props?.contractSummaryLoader? <ListLoader /> : null}
        {Object.keys(invoiceInfo).length ?
          <div className="add-edit-invoice-form view-block" >
             <Row className="company-form-block invoice-heading">
              <Col xs={6}>
                <Link className="back-link" to={`/${this.props.params.type}/${this.props.params.aircraft_slug}/contract/${this.props.params.contract_slug}/invoice`}>
                  <img width="15" src={imgStoragePath + "back_arw.png"} alt="img" />
                  <div className="inv-back-info">
                    <span>{invoiceDescList[invoiceInfo.invoice_type] + ' Invoice'}{jetStreamInstance && invoiceInfo.invoice_type===2 && invoiceInfo?.rental_invoice_type?<span style={{fontWeight:'bold',textTransform:'uppercase',fontFamily:'Conv_IBMPlexSans-Medium'}}>({invoiceInfo?.rental_invoice_type?.label})</span>:null}</span><br />
                    <h6>Invoice {'#' + invoiceInfo.invoice_number}</h6>
                    {invoiceInfo?.parent_invoice_number ?
                    <span style={{fontSize:'14px', display:'flex'}}>Parent Invoice:<p onClick={(e)=>{e.preventDefault(); e.stopPropagation();window.open(`/${this.props.params.type}/${this.props.params.aircraft_slug}/contract/${this.props.params.contract_slug}/invoice/view/${invoiceInfo?.parent}/`)}} onMouseEnter={(e) => e.target.style.color = '#6083e2'} onMouseLeave={(e) => e.target.style.color = '4050b5'} style={{textDecoration:'underline', color:'#4050b5', fontSize:'12px', cursor:'pointer'}}>{invoiceInfo?.parent_invoice_number}</p></span>:null}
                  </div>
                </Link>
              </Col>
              <Col xs={6}>
                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                  {(invoiceInfo.status == '1' || invoiceInfo.status == '2')&& checkPermission('contracts', 'invoices', 'U') && contractInfo?.hdlineInfo?.archived_asset === false && invoiceInfo.summary_invoice_enabled === false ?
                    <li className='list-inline-item'>
                      {approverInfo?.approval_status?.approval_status_code===2 && approverInfo?.approval_status?.current_stage!==1 || approverInfo?.approval_status?.current_stage===1&&approverInfo?.approval_status?.user_has_permission===false && approverInfo?.approval_status?.approval_status_code===2 || approverInfo?.approval_status?.current_stage===1 && !invoiceInfo.is_reserve_releted && ![1,4].includes(approverInfo?.approval_status?.approval_status_code) || approverInfo?.approval_status?.approval_status_code===3 ? (
                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}> <img width="16" src={editIcon} alt="img" /> Edit </span>
                      ) : (
                        <Link to={'/' + this.props.params.type + '/' + this.props.params.aircraft_slug + '/contract/' + this.props.params.contract_slug + '/invoice/edit/' + this.props.params.id} className="edit-icon edit-icon-bar"><img width="16" src={editIcon} alt="img" /> Edit</Link>)}                    
                      </li> : null
                  }
                  {(invoiceInfo.status == '1' || invoiceInfo.status == '2')&& checkPermission('contracts', 'invoices', 'U') && contractInfo?.hdlineInfo?.archived_asset === false  ?
                    <li className='list-inline-item'>
                      { [1,2].includes(approverInfo?.approval_status?.current_stage) && approverInfo?.approval_status?.approval_status_code!==3 && approverInfo?.approval_status?.is_invoice_approval === true  || approverInfo?.approval_status?.current_stage === 3 && approverInfo?.approval_status?.approval_status_code!==3 && approverInfo?.approval_status?.is_invoice_approval === true && approverInfo?.approval_status?.status!=="approve" ? (
                        <span style={{ opacity: 0.5, cursor: 'not-allowed',float: 'right', borderRight: '1px solid #3f51b5', padding: '0 10px',  borderLeft:invoiceInfo.summary_invoice_enabled === false? '1px solid #3f51b5':'' }}><img style={{ width: "16px", paddingBottom: '3px'}} src={emailIcon} alt="export" /> Send Email</span>
                      ) : (
                        <span onClick={this.props.getShareInvoiceInfo} style={{ color: '#3f51b5', cursor: 'pointer', fontSize: '14px', float: 'right', borderRight: '1px solid #3f51b5', padding: '0 10px',  borderLeft:invoiceInfo.summary_invoice_enabled === false? '1px solid #3f51b5':'' }}><img style={{ width: "16px", paddingBottom: '3px' }} src={emailIcon} alt="export" /> Send Email</span>)}                    
                      </li> : null
                  }
                  {checkPermission('contracts', 'invoices', 'D') && ([1,2,4].includes(invoiceInfo.status)) && contractInfo?.hdlineInfo?.archived_asset === false  && invoiceInfo.summary_invoice_enabled === false ?
                    <li className='list-inline-item'>
                    {[2,3,4].includes(approverInfo?.approval_status?.approval_status_code) && approverInfo?.approval_status?.user_has_permission === false ?
                      <span style={{ opacity: 0.5, cursor: 'not-allowed', borderRight: '1px solid #3f51b5', paddingRight: '10px' }}> Delete </span>
                      :
                      <span style={{ fontSize: '14px', paddingRight: '10px', color: '#ff0000', cursor: 'pointer', fontFamily: '$ibmplexRegular', borderRight: '1px solid #3f51b5' }} onClick={() => this.setState({ deleteInvoice: true })} >Delete</span>}
                    </li> : null
                  }
                  {
                    invoiceInfo?.status == 2 && invoiceInfo?.qb_enabled && invoiceInfo?.qb_enabled == true && [13, 442].includes(getLocalStorageInfo().defaultLessor?.id) ?
                      <li>
                        <span onClick={() => {this.getThirdPartyFn({ invoice_id: this.props?.params?.id })}} style={{ color: '#3f51b5', cursor: 'pointer', fontSize: '14px', float: 'right', borderRight: '1px solid #3f51b5', padding: '0 10px' }}>Sync to QB
                        {/* <span onClick={() => this.getThirdPartyAppUrl({ invoice_id: this.props?.params?.id })} style={{ color: '#3f51b5', cursor: 'pointer', fontSize: '14px', float: 'right', borderRight: '1px solid #3f51b5', padding: '0 10px' }}>Sync to QB */}
                          <Tooltip title={<table>
                            <tbody className='qb-status-tooltip'>
                              <tr >
                                <td>Last Updated By:&nbsp; </td>
                                <td>{invoiceInfo?.qb_last_sync_by?.name || '--'} {' '}({invoiceInfo?.qb_last_sync_time ? moment(invoiceInfo?.qb_last_sync_time).format('MMM DD, YYYY') : '--'})</td>
                              </tr>
                            </tbody>
                          </table>} arrow placement='top'>
                            <span >
                              <InfoIcon />
                            </span>
                          </Tooltip>
                        </span>
                      </li>
                      :
                      (invoiceInfo?.qb_invoice !== null && invoiceInfo?.status !== 2 && invoiceInfo?.status !== 1 ?
                      <li className='list-inline-item'>
                                        <Tooltip disableInteractive title={<table>
                                            <tbody className='qb-status-tooltip' >
                                                <tr>
                                                    <td>Sync Status(QB):</td>
                                                    <td>Already Synchronized on QB</td>
                                                </tr>
                                                <tr>
                                                    <td>Last Updated By:&nbsp; </td>
                                                    <td>{invoiceInfo?.qb_last_sync_by?.name || '--'} {' '}({invoiceInfo?.qb_last_sync_time ? moment(invoiceInfo?.qb_last_sync_time).format('MMM DD, YYYY') : '--'})</td>
                                                </tr>
                                            </tbody>
                                        </table>} arrow placement='top'>
                                            <span>
                                                <InfoRoundedIcon fontSize='small' style={{ color: 'rgb(174 172 172)',display:'flex'}} />
                                            </span>
                                        </Tooltip>
                                </li>:null)
                  }
                  {checkPermission('contracts', 'invoices', 'EXP') ?
                    <li className='list-inline-item'>
                      <div className="download-block">
                        <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleExport}>
                          <DropdownToggle caret size="sm">
                            <span><img width="12" src={exportIcon} alt="export" /> Export </span>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, invoiceInfo.invoice_number, 'pdf', invoiceInfo)}><img src={imgStoragePath + "pdf_icon.png"} alt="img" />PDF</DropdownItem>
                            {!titanInstance && (<>
                            <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, invoiceInfo.invoice_number, 'xls', invoiceInfo)} ><img src={imgStoragePath + "excel_icon.png"} alt="img" />Excel</DropdownItem>
                            <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, invoiceInfo.invoice_number, 'docx', invoiceInfo)} ><img src={imgStoragePath + "docs_icon.png"} alt="img" />Doc</DropdownItem>
                            <DropdownItem onClick={() => this.props.exportInvoice(ctrShortInfo, invoiceInfo.invoice_number, 'csv', invoiceInfo)} ><img src={imgStoragePath + "excel_icon.png"} alt="img" />CSV</DropdownItem>
                            </>)}
                          </DropdownMenu>
                        </ButtonDropdown>
                      </div>
                    </li> : null
                  }
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
              <ul className='list-inline flex-centered' >
                  {this.state.approvalDetailsLoaded && (approverInfo?.approval_status?.approval_status_code !==0 || approverInfo?.approval_status?.is_invoice_approval === true ?
                    <li className='list-inline-item' style={{marginLeft:titanInstance && invoiceInfo?.invoice_type === 1 || titanInstance && invoiceInfo?.parent_invoice_type === 1 || titanInstance && invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true?null:'38px',textAlign: titanInstance && invoiceInfo?.invoice_type === 1 || titanInstance && invoiceInfo?.parent_invoice_type === 1|| titanInstance && invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true?'center':'',width:titanInstance?'100%':null}}>
                        <span style={{ paddingRight: '10px',  }}>
                        {!(titanInstance) ?
                          <MuiButton style={{ padding: '0px 2px' }} disabled={invoiceInfo?.status !==1 || approverInfo?.approval_status?.approval_status_code === 3 || ([2, 3].includes(approverInfo?.approval_status?.approval_status_code) && approverInfo?.approval_status?.user_has_permission === false) || approverInfo?.approval_status?.approval_status_code === 4 && getLocalStorageInfo().user?.id !== lastCreatedById && approverInfo?.approval_status?.user_has_permission === false} variant='outlined' size='small' color='primary' onClick={() => this.setState({ approverModal: true })}>
                            {approverInfo?.approval_status?.approval_status_code === 1 ? 'Send for Approval' : approverInfo?.approval_status?.approval_status_code === 4 && approverInfo?.approval_status?.user_has_permission === false ? 'Rejected' : approverInfo?.approval_status?.approval_status_code === 4 ? 'Send For Re-Approval' : approverInfo?.approval_status?.approval_status_code === 3 ? 'Approved' : approverInfo?.approval_status?.approval_status_code === 2 && approverInfo?.approval_status?.user_has_permission === false ? 'Pending' : 'Approve/Reject'}
                          </MuiButton>
                          :<>
                            {invoiceInfo?.invoice_type === 2 || invoiceInfo?.parent_invoice_type === 2|| invoiceInfo?.parent_invoice_type === 9 && invoiceInfo.is_reserve_releted === false || invoiceInfo?.invoice_type === 6 || invoiceInfo.is_independent_invoice && [4,5].includes(invoiceInfo?.invoice_type) ?
                              <MuiButton style={{ padding: '0px 2px' }} disabled={ invoiceInfo?.status !==1 || approverInfo?.approval_status?.approval_status_code === 3 || ([2, 3].includes(approverInfo?.approval_status?.approval_status_code) && approverInfo?.approval_status?.user_has_permission === false) || approverInfo?.approval_status?.approval_status_code === 4 && getLocalStorageInfo().user?.id !== lastCreatedById && approverInfo?.approval_status?.user_has_permission === false} variant='outlined' size='small' color='primary' onClick={() => this.setState({ approverModal: true })}>
                                {approverInfo?.approval_status?.approval_status_code === 1 ? 'Send for Approval' : approverInfo?.approval_status?.approval_status_code === 4 && approverInfo?.approval_status?.user_has_permission === false ? 'Rejected' : approverInfo?.approval_status?.approval_status_code === 4 ? 'Send For Re-Approval' : approverInfo?.approval_status?.approval_status_code === 3 ? 'Approved' : approverInfo?.approval_status?.approval_status_code === 2 && approverInfo?.approval_status?.user_has_permission === false ? 'Pending' : 'Approve/Reject'}
                              </MuiButton> :
                              <MuiButton style={{ padding: '0px 2px' }} disabled={invoiceInfo?.status !==1 || approverInfo?.approval_status?.approval_status_code === 2 && approverInfo?.approval_status?.user_has_permission === false || approverInfo?.approval_details?.[0]?.status === "approved" && approverInfo?.approval_details?.[0]?.stage === 3 || approverInfo?.approval_status?.approval_status_code === 3 && !approverInfo?.approval_details?.[0]?.status === "approved" || ([1, 2, 3, 4].includes(approverInfo?.approval_status?.approval_status_code) && approverInfo?.approval_status?.user_has_permission === false) || approverInfo?.approval_status?.approval_status_code === 4 && getLocalStorageInfo().user?.id !== approverInfo?.approval_info?.id && approverInfo?.approval_status?.user_has_permission === false && !approverInfo?.approval_details?.[0]?.status === "approved"} variant='outlined' size='small' color='primary' onClick={() => this.setState({ approverModal: true })}>
                                {approverInfo?.approval_status?.approval_status_code === 1 || approverInfo?.approval_status?.approval_status_code === 3 && approverInfo?.approval_details?.[0]?.status === "approved" && approverInfo?.approval_details?.[0]?.stage !== 3 ? `Send for Approval (${getStageName(displayStage)})` : approverInfo?.approval_status?.approval_status_code === 4 ? `Send For Re-Approval (${getStageName(displayStage)})` : approverInfo?.approval_status?.approval_status_code === 3 && approverInfo?.approval_details?.[0]?.status === "approved" && approverInfo?.approval_details?.[0]?.stage === 3 ? `Approved (${getStageName(displayStage)})` : approverInfo?.approval_status?.approval_status_code === 2 && approverInfo?.approval_status?.user_has_permission === false ? `Pending (${getStageName(displayStage)})` : `Approve/Reject (${getStageName(displayStage)})`}
                              </MuiButton>
                            }
                          </>
                        }
                        {(!titanInstance && approverInfo?.approval_details ) || (titanInstance && invoiceInfo.is_reserve_releted !== true && approverInfo?.approval_details)  ?
                        <Tooltip title={<table>
                          <tbody>
                            {approverInfo?.approval_details?.length ?
                              <tr>
                                <td>{approverInfo?.approval_status?.approval_status_code === 2 ? 'Sent for Approval By' : approverInfo?.approval_status?.approval_status_code === 3 ? 'Approved By' : approverInfo?.approval_status?.approval_status_code === 4 ? "Rejected By" : 'Updated By'}: {approverInfo?.approval_details?.[0]?.created_by?.name || '--'} {' '}({approverInfo?.approval_details?.[0]?.created_by?.name ? moment(approverInfo?.user_info?.time).format(displayDateTimeFormatShort) : '--'}) </td>
                              </tr> : null}
                            {/* {titanInstance && invoiceInfo?.invoice_type === 1 || titanInstance && invoiceInfo?.parent_invoice_type === 1 || titanInstance && invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true ?
                              <tr>
                                {(approverInfo?.approval_status?.approval_status_code === 4 && [1, 2, 3].includes(approverInfo?.approval_status?.current_stage) && approverInfo?.approval_status?.status === 'reject' || approverInfo?.approval_status?.approval_status_code === 1 && approverInfo?.approval_status?.current_stage === 1 || approverInfo?.approval_status?.approval_status_code === 3 && [1, 2].includes(approverInfo?.approval_status?.current_stage)) ?
                                  <td>
                                    {(invoiceInfo?.invoice_type === 1 || invoiceInfo?.parent_invoice_type === 1 || invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) && approverInfo.approval_status.working_group_id ?
                                      <div>Approver process for {getStageName(displayStage)} can be Initiated By Working Group : {this.state.approver.find((item) => item?.id === approverInfo?.approval_status.working_group_id)?.name || "--"}</div>
                                      :
                                      [2,6].includes(invoiceInfo?.invoice_type) && approverInfo?.approval_status?.status === 'enable' || invoiceInfo?.parent_invoice_type === 2 && invoiceInfo.is_independent_invoice === true && approverInfo?.approval_status?.status === 'enable' || [4, 5].includes(invoiceInfo.invoice_type) && invoiceInfo.is_independent_invoice === true && ['enable', 'reject'].includes(approverInfo?.approval_status?.status) ||
                                       invoiceInfo.parent_invoice_type === 2 && approverInfo?.approval_status?.status === 'reject'||[2,6].includes(invoiceInfo.invoice_type) && approverInfo?.approval_status?.status === 'reject' || (invoiceInfo?.invoice_type === 1 || invoiceInfo?.parent_invoice_type === 1||invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) && !approverInfo.approval_status.working_group_id|| invoiceInfo.invoice_type === 6 ?
                                        <div>Approver process for {getStageName(displayStage)} can be Initiated By Titan Team Members</div>
                                        :
                                        <div>Approver process for {getStageName(displayStage)} can be Initiated By Working Group : {this.state.approver.find((item) => item?.id === approverInfo?.approval_status.working_group_id)?.name || "--"}</div>
                                    }
                                  </td> :
                                  approverInfo?.approval_status?.approval_status_code === 2 && [1, 2, 3].includes(approverInfo?.approval_status?.current_stage) ?
                                    <td>
                                      <div>This can be approved/rejected by working group : {this.state.approver.find((item) => item.id === approverInfo?.approval_status.working_group_id)?.name || "--"}</div>
                                    </td> : null
                                }
                              </tr> : null} */}
                          </tbody>
                        </table>} arrow placement='top'>
                          <span > 
                           { !titanInstance ? approverInfo?.approval_details?.length ? <InfoIcon /> : null : invoiceInfo?.invoice_type === 2 || invoiceInfo?.parent_invoice_type === 9 && invoiceInfo.is_reserve_releted === false || invoiceInfo?.parent_invoice_type === 2 || invoiceInfo?.invoice_type === 6 || invoiceInfo.is_independent_invoice && [4,5].includes(invoiceInfo?.invoice_type)? approverInfo?.approval_details?.length?<InfoIcon />:null:<InfoIcon />}
                          </span>
                        </Tooltip>
                          : null}
                        {titanInstance && approverInfo?.approval_details?.length && invoiceInfo?.is_reserve_releted === true ? <span style={{ margin: "0px 0px 0px 0px" }}> <Tooltip title={"Approval History"}><Link
                          style={{ 'marginRight': '2px', 'display': 'inline-block' }}
                          onClick={() => {this.setState({ timelineModal: true })} }
                        >
                          <img className="audit-img" width="18" src={revisionHistoryIcon} alt="img" />
                        </Link></Tooltip> </span> : null}
                        <span>
                            {approverInfo?.approval_status?.approval_status_code === 4 && approverInfo?.approval_status?.user_has_permission === false ?<>
                            <br/><span style={{background:'yellow', padding:'2px', marginTop:'2px', fontSize:'10px', display: titanInstance?"ruby":'inline-block'}}>The user does not have permission to change the Approval Status. This action can only be  performed by the person who initiated the approval process or a member of the assigned working group.</span></>:null}
                            {approverInfo?.approval_status?.approval_status_code === 2 && approverInfo.approval_status.user_has_permission === false ?<>
                            <br/><span style={{background:'yellow', padding:'2px', marginTop:'2px', fontSize:'10px', display: titanInstance?"ruby":'inline-block'}}>The user does not have permission to change the Approval Status. This action can only be performed by the person who is a member of the assigned working group.</span></>:null}
                            </span>
                        {(titanInstance && invoiceInfo?.invoice_type === 1 || titanInstance && invoiceInfo?.parent_invoice_type === 1 || titanInstance && invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) ?
                          <div style={{ width: "100%", overflowX: "auto", padding: "20px 0" }}>
                            <Stepper
                              style={{ padding: '5px' }}
                              alternativeLabel
                              activeStep={activeStage}
                              connector={<StepConnector classes={{ alternativeLabel: "alt-label", active: "active-connector", completed: "completed-connector", line: "default-connector-line", }} />}
                            >
                              {stages.map((step, index) => (
                                <Step key={index} completed={step?.status === "approved"} style={{ flex: 1, minWidth: "200px" }} >
                                  <StepLabel
                                    StepIconComponent={(props) => {
                                      const { active, completed, error, icon } = props;
                                      return (
                                        <div style={{
                                          backgroundColor: invoiceInfo?.status !==1 && approverInfo?.approval_status?.status !== "approved" ? "#bdbdbd" : (error ? "red" : index + 1 === effectiveStage && step?.status === "pending" || index + 1 === approverInfo?.approval_status?.current_stage && step?.status === "pending"||index + 1 === approverInfo?.approval_status?.current_stage && approverInfo?.approval_status.current_stage !== 3 ? "#3f51b5" : index + 1 > effectiveStage  ? "#bdbdbd" : approverInfo?.approval_status?.current_stage === 3 && active &&  !completed || index + 1 === effectiveStage && !completed || approverInfo?.approval_status?.current_stage === 2 && approverInfo?.approval_status?.status === 'reject' ? "#bdbdbd" :""),
                                          color:invoiceInfo?.status !==1 && approverInfo?.approval_status?.status !== "approved" ? "white" : (index + 1 <= approverInfo?.approval_status?.current_stage && approverInfo?.approval_status?.is_rejected === false && step?.status === "approved" && completed || (approverInfo?.approval_status?.current_stage === 3 ? (step?.status === "approved" && index + 1 < effectiveStage) : (step?.status === "approved" && index + 1 < effectiveStage + 1 || step?.status === "approved" && index + 1 < effectiveStage - 1)) && approverInfo?.approval_status.current_stage === 2  ? "green" : "white"),
                                          width: 20, height: 20, fontSize: 10, fontWeight: "bold", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 8,
                                        }} >
                                          {invoiceInfo?.status !==1 && approverInfo?.approval_status?.status !== "approved" ? icon  :  approverInfo?.approval_status?.current_stage === 2 && approverInfo?.approval_status?.status === 'pending' && index < effectiveStage && approverInfo.approval_details?.[0]?.stage ===3 ?<CheckCircleIcon/>: (approverInfo?.approval_status?.is_rejected === true ? step?.status === "approved" && index+1 < effectiveStage : step?.status === "approved") && index+1 < effectiveStage+1 ? <CheckCircleIcon fontSize="small" /> : icon}
                                        </div>
                                      )
                                    }}
                                  >
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", }} >
                                      <div style={{  color:invoiceInfo?.status !==1 && approverInfo?.approval_status?.status !== "approved" ? "#757575" : "inherit",fontSize: "16px", fontWeight: "600", marginBottom: 4, display:'flex' }} >
                                        {index + 1 === 1 ? "FINANCE CONTROL" : index + 1 === 2 ? "ACCOUNTING CONTROL" : "FINAL CONTROL"} <Tooltip title={'Attachments'} ><AttachFileIcon onClick={() => { this.getAttachments(); this.setState({ selectedStage: index + 1, attachmentModalOpen: true }); }} fontSize='small' color='primary' style={{ cursor: 'pointer' }} /></Tooltip>
                                      </div>
                                      <div style={{ textTransform: "capitalize", fontSize: "14px", fontWeight: "500", color: invoiceInfo?.status !==1 && approverInfo?.approval_status?.status !== "approved" ?  "#757575" : step?.status === "rejected" ? "red" : index + 1 <= approverInfo?.approval_status?.current_stage && approverInfo?.approval_status?.is_rejected===false  && step?.status === "approved"||index < approverInfo?.approval_status?.current_stage - 1 &&approverInfo?.approval_status.is_rejected ? "green" : step?.status === "pending"||index + 1 === approverInfo?.approval_status?.current_stage ? "#3f51b5" : "#757575", }} >
                                        { approverInfo?.approval_status?.is_rejected === true ? index + 1 === approverInfo?.approval_status?.current_stage  ? "Pending" : index + 1 < approverInfo?.approval_status?.current_stage - 1 ? "Approved" :index < approverInfo?.approval_status?.current_stage - 1 &&approverInfo?.approval_status.is_rejected?"Approved": "Not Started" : index + 1 > approverInfo?.approval_status?.current_stage ? "Not Started" : step?.status || "Not Started" }
                                      </div>
                                    </div>
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                          </div> : null}
                        </span>
                    </li>:null)}
                  </ul>
              </Col>
            </Row>
            <form onSubmit={(e) => this.createInvoice(e)} style={{ padding: '1px', marginTop: '10px' }}>
              <InvoiceInfo
                viewTimeline={() => this.setState({ showStatusTimeLine: true })}
                type={'view'}
                contractInfo={contractInfo}
                invoiceInfo={invoiceInfo} toggleInvoiceState={() => this.toggle()}
                invoiceStatusList={invoiceStatusList}
                startDate={startDate}
                endDate={endDate}
                approverInfo={this.state.approverInfo}
              />
              {gaTelesisInstance ? <InvFields type="text" label="Remarks" colSize="3" value={invoiceInfo?.remarks} />: null }
              <Row className="margin-0 company-form-block">
                <LessorInfo
                  invoiceInfo={invoiceInfo}
                  type="view"
                />
                <LesseeInfo
                  invoiceInfo={invoiceInfo}
                  type="view"
                />
              </Row>
              {invoiceInfo.invoice_type == 2 && invoiceInfo.rental_description && invoiceInfo.rental_description != '' ?
                <Row className="margin-0 company-form-block">
                  <Col md="12" className="padding-right-0">
                    <Row className="inner-wrap"
                      style={{ background: '#fafafa', padding: '0 15px', marginRight: '15px' }}
                    >
                      <InvFields label="Description" colSize="12" padding='padding-left-0' value={invoiceInfo.rental_description ? invoiceInfo.rental_description : '--'} />
                    </Row>
                  </Col>
                </Row> : null
              }
              <div className="charge-description-block " >
                {invoiceInfo.invoice_type === 9 ?
                  <div>
                    <div className="table-block">
                      <table className="contr-table invoice-table-style">
                        {
                          isJac ?
                            <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Sub Total (' + invoiceInfo.currency + ')']} />
                            :(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice?
                            <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')','JCT Rate','JCT Amount']} />:
                            titanInstance && invoiceInfo.is_reserve_releted ?<CtrTableHd theads={['Item', 'FH:FC', 'Unit Description', 'No. Of Units', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />:
                            titanInstance?<CtrTableHd theads={['Item', 'Unit Description', 'No. Of Units', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />:
                            <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />
                        }
                        <tbody>
                          {invoiceInfo.invoice_items.map((invoice_item, index) => (
                            invoiceInfo.parent_invoice_type == 1 ?
                              <MRAdhocInvoiceItem
                              showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                isJac={isJac}
                                key={index}
                                type="view"
                                invoiceInfo={invoiceInfo}
                                invoice_item={invoice_item}
                                value={invoice_item}
                                index={index}
                                validationArray={this.state.validationArray}
                                updateInvoiceItemField={(value, type, index, name, unit_type) => this.props.updateInvoiceItemField(value, type, index, name, unit_type)}
                              />
                              : <RentalAdhocInvoiceItem
                              showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                key={index}
                                isJac={isJac}
                                type="view"
                                invoiceInfo={invoiceInfo}
                                value={invoice_item}
                                invoice_item={invoice_item}
                                index={index}
                                validationArray={this.state.validationArray}
                                updateInvoiceItemField={(value, type, index, name, unit_type) => this.props.updateInvoiceItemField(value, type, index, name, unit_type)}
                              />
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="sub-total-block">
                      <h5 className="para-ui">Billable Amount:
                        <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                          {
                            invoiceInfo.invoice_items.reduce((total, next) => total + parseFloat(next.billable_amount), 0)
                          }
                        </NumericLabel>
                      </h5>
                      {
                        invoiceInfo.status == '5' ?
                          <h5 className="para-ui">Paid Amount :
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {invoiceInfo.partial_paid_amount}
                            </NumericLabel>
                          </h5> : null
                      }
                      {
                        isJac ?
                          null :
                          <h5 className="para-ui">Tax:
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {
                                invoiceInfo.invoice_items.reduce((total, next) => total + next.tax_amount, 0)
                              }
                            </NumericLabel>
                          </h5>}
                          {(gaTelesisInstance || Lessor_test) && invoiceInfo?.jct_invoice?
                          <h5 style={{marginTop:"10px"}} className="para-ui">JCT (10% of Total):
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                            {invoiceInfo.jct_tax_amount ? invoiceInfo.jct_tax_amount : 0}
                          </NumericLabel>
                        </h5>
                       :null}
                      <h4 className="para" style={{ display: 'inline-flex' }}>Total:
                        {(gaTelesisInstance || Lessor_test) && invoiceInfo?.jct_invoice ?
                          <>
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {invoiceInfo.status == "5" ? JctDiff : invoiceInfo?.total_amount}
                            </NumericLabel>
                            {totalExcessAmounts > 0 ?
                              <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                              </Tooltip> : null}
                          </>
                          :
                          <>
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {invoiceInfo.status == "5" ? diff : total}
                            </NumericLabel>
                            {totalExcessAmounts > 0 ?
                              <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                              </Tooltip> : null}
                          </>}
                      </h4>
                      <this.TotalOffset invoiceInfo={invoiceInfo}/> 
                      <this.GrandTotal invoiceInfo={invoiceInfo}/> 
                    </div>
                  </div>
                  : (invoiceInfo.invoice_type == 1 || invoiceInfo.invoice_type == 2) ?
                    <div>
                      {invoiceInfo.invoice_type == 2 ? <h5 className="para currency-break">{invoiceInfo.currency} Rental Receivable</h5> : null}
                      <div className="table-block">
                        <table className="contr-table invoice-table-style">
                          {
                            isJac ?
                              <CtrTableHd theads={invoiceInfo.interval === 5 ? ['Item', 'Description', 'Unit Description', 'No. Of Days', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Sub Total (' + invoiceInfo.currency + ')'] : ['Item', 'Description', 'Unit Description', 'No. Of Units', 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Sub Total (' + invoiceInfo.currency + ')']} />
                              : (gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice ?
                              <CtrTableHd theads={invoiceInfo.interval === 5 ? ['Item', 'Description', 'Unit Description', 'No. Of Days', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')','JCT Rate','JCT Amount '] : ['Item', 'Description', 'Unit Description', 'No. Of Units', 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')', 'JCT Rate','JCT Amount ']} />:
                              titanInstance && invoiceInfo.invoice_type==1?<CtrTableHd theads={invoiceInfo.interval === 5 ? ['Item', 'FH:FC', 'Unit Description', 'No. Of Days', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')'] : ['Item', 'FH:FC', 'Unit Description', 'No. Of Units', 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />
                              :titanInstance?<CtrTableHd theads={invoiceInfo.interval === 5 ? ['Item', 'Unit Description', 'No. Of Days', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')'] : ['Item', 'Unit Description', 'No. Of Units', 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />
                              :<CtrTableHd theads={invoiceInfo.interval === 5 ? ['Item', 'Description', 'Unit Description', 'No. Of Days', invoiceInfo.rental_type === 1 ? 'Fixed Rate (' + invoiceInfo.currency + ')' : 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')'] : ['Item', 'Description', 'Unit Description', 'No. Of Units', 'Fixed / Per Unit Rate (' + invoiceInfo.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />
                          }
                          <tbody>
                            {invoiceInfo.invoice_items.map((value, index) => (
                              invoiceInfo.invoice_type === 1 ?
                                <MaintenanceInvoiceItem
                                  showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                  isJac={isJac}
                                  key={index}
                                  type="view"
                                  value={value}
                                  invoiceInfo={invoiceInfo}
                                />
                                : <RentalInvoiceItem
                                  showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                  isJac={isJac}
                                  key={index}
                                  type="view"
                                  invoice_item={value}
                                  invoiceInfo={invoiceInfo}
                                  validationArray={[]}
                                />
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="sub-total-block">
                        <h5 className="para-ui">Billable Amount :
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                            {invoiceInfo.invoice_items.reduce((total, next) =>
                              total + parseFloat(parseFloat(next.billable_amount).toFixed(2)), 0
                            )}
                          </NumericLabel>
                        </h5>
                        {
                          invoiceInfo.status == '5' && !titanInstance ?
                            <h5 className="para-ui">Paid Amount :
                              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoiceInfo.partial_paid_amount}
                              </NumericLabel>
                            </h5> : null
                        }
                        {
                          isJac ?
                            null :
                            <h5 className="para-ui">Tax:
                              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoiceInfo.invoice_items.reduce((total, next) =>
                                  total + parseFloat(parseFloat(next.tax_amount).toFixed(2)) , 0
                                )}
                              </NumericLabel>
                            </h5>}
                            {(gaTelesisInstance || Lessor_test)  && invoiceInfo?.jct_invoice?
                          <h5 style={{marginTop:"10px"}} className="para-ui">JCT (10% of Total):
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                          {(invoiceInfo.non_jct_total ? invoiceInfo.non_jct_total : invoiceInfo.sub_total !== undefined && invoiceInfo.sub_total !== null && invoiceInfo.sub_total !== '' ? invoiceInfo.sub_total : invoiceInfo.status == "5" ? diff : total)/10}
                          </NumericLabel>
                        </h5> :null}  
                        <h4 className="para" style={{display:'inline-flex'}}>Total:
                        {(gaTelesisInstance || Lessor_test) && invoiceInfo?.jct_invoice ?
                          <>
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {invoiceInfo.status == "5" ? JctDiff : invoiceInfo?.total_amount}
                            </NumericLabel>
                            {totalExcessAmounts > 0 ?
                              <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                              </Tooltip> : null}
                          </>
                          :
                          <>
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {invoiceInfo.status == "5" ? titanInstance? total: diff : total}
                            </NumericLabel>
                            {totalExcessAmounts > 0 ?
                              <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                              </Tooltip> : null}
                          </>}
                        </h4>
                        {
                          invoiceInfo.status == '5' && titanInstance ?
                            <h5 className="para-ui">Paid Amount :
                              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoiceInfo.partial_paid_amount}
                              </NumericLabel>
                            </h5> : null
                        }
                        <this.TotalOffset invoiceInfo={invoiceInfo}/>
                        <this.GrandTotal invoiceInfo={invoiceInfo}/> 
                      </div>
                    </div>
                    :(invoiceInfo.invoice_type == 10 ) ?
                    <div>
                      <div className="table-block">
                        <table className="contr-table invoice-table-style">
                              <CtrTableHd theads={['Item', 'Description', 'Rental Amount(' + invoiceInfo.currency + ')', 'Management Fee %',  'Management Fee Amount(' + invoiceInfo.currency + ')', 'VAT %', 'VAT Amount(' + invoiceInfo.currency + ')', 'Total(' + invoiceInfo.currency + ')']} />
                                              
                          <tbody>
                            {invoiceInfo.invoice_items.map((value, index) => (                         
                                <ManagementFee
                                  key={index}
                                  type="view"
                                  value={value}
                                  invoice_item={value}
                                  invoiceInfo={invoiceInfo}
                                />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>:<>{ (invoiceInfo.invoice_type == 4 || invoiceInfo.invoice_type == 5) ?
                      <div>
                      <div className="table-block">
                        <table className="contr-table invoice-table-style">
                          {(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice? <CtrTableHd theads={['Item', 'Amount', 'Tax Rate (%)', 'Tax Amount', 'Total (USD)','JCT Rate','JCT Amount ']} />:
                          isJac ? <CtrTableHd theads={['Item', 'Amount', 'Total (USD)']} />:
                          hanwahaInstance?
                          <CtrTableHd theads={['Item','Description', 'Amount', 'Tax Rate (%)', 'Tax Amount', 'Total (USD)']} />:
                          titanInstance && invoiceInfo.is_reserve_releted ?<CtrTableHd theads={['Item', 'FH:FC', 'Amount', 'Tax Rate (%)', 'Tax Amount', 'Total (USD)']} />:
                          <CtrTableHd theads={['Item', 'Amount', 'Tax Rate (%)', 'Tax Amount', 'Total (USD)']} />}
                          <tbody>
                            {invoiceInfo.invoice_items.map((invoice_item, index) => (
                            <CreditDebitNote
                              isJac ={isJac}
                              showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                              type="view"
                              key={index}
                              invoice_item={invoice_item}
                              invoiceInfo={invoiceInfo}
                              updateInvoiceItemField={this.updateInvoiceItemField}
                              newInvoiceDate={invoiceDate.isSameOrAfter(newInvoiveDate)}
                            />))}
                          </tbody>
                        </table>
                        </div>
                        {invoiceDate.isSameOrAfter(newInvoiveDate) ?
                        <div className="sub-total-block">
                          <h5 className="para-ui">Billable Amount:
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                              {
                                invoiceInfo.invoice_type === 5 ? -(invoiceInfo.invoice_items.reduce((total, next) => total + parseFloat(next.billable_amount), 0)):
                                (invoiceInfo.invoice_items.reduce((total, next) => total + parseFloat(next.billable_amount), 0))
                              }
                            </NumericLabel>
                          </h5>
                          {isJac ? null :
                            <h5 className="para-ui">Tax :
                              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoiceInfo.invoice_type === 5 ? -(invoiceInfo.invoice_items.reduce((total, next) => total + parseFloat(parseFloat(next.tax_amount).toFixed(2)), 0 )):
                                (invoiceInfo.invoice_items.reduce((total, next) => total + parseFloat(parseFloat(next.tax_amount).toFixed(2)), 0 ))}
                              </NumericLabel>
                            </h5>
                          }
                          {(gaTelesisInstance || Lessor_test) && invoiceInfo?.jct_invoice ?
                            <h5 style={{ marginTop: "10px" }} className="para-ui">JCT (10% of Total):
                              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoiceInfo.invoice_type === 5 ? -(invoiceInfo.jct_tax_amount ? invoiceInfo.jct_tax_amount : 0) : (invoiceInfo.jct_tax_amount ? invoiceInfo.jct_tax_amount : 0)}
                              </NumericLabel>
                            </h5>
                            : null}
                            <h4 className="para" style={{display:'inline-flex'}}>Total:
                              {(gaTelesisInstance || Lessor_test) && invoiceInfo?.jct_invoice ?
                                <>
                                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                    {invoiceInfo.invoice_type == "5" ? -(invoiceInfo?.total_amount) : invoiceInfo?.total_amount}
                                  </NumericLabel>
                                  {totalExcessAmounts > 0 ?
                                    <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                      <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                                    </Tooltip> : null}
                                </>
                                :
                                <>
                                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                    {invoiceInfo.invoice_type === 5 ? `-${total}` : total}
                                  </NumericLabel>
                                  {totalExcessAmounts > 0 ?
                                    <Tooltip title={`Total Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${totalExcessAmounts}`}>
                                      <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                                    </Tooltip> : null}
                                </>}
                            </h4>
                          </div> : null}
                      </div>
                      :
                      invoiceInfo.invoice_type === 6 ?
                      <div>
                        <div className="table-block">
                          <table className="contr-table invoice-table-style">
                          {(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice? <CtrTableHd theads={['Item', 'Security Against', 'Security Deposit Type', ' Security Deposit Amount', 'Sub Total (' + invoiceInfo.currency + ')','JCT Rate','JCT Amount ']} />:
                            <CtrTableHd theads={['Item', 'Security Against', 'Security Deposit Type', ' Security Deposit Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />}
                            <tbody>
                              <SecurityInvoiceItem
                              showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                type="view"
                                invoice_item={invoiceInfo?.invoice_items?.length ? invoiceInfo.invoice_items[0] : []}
                                invoiceInfo={invoiceInfo}
                              />
                            </tbody>
                          </table>
                        </div> 
                        </div>:
                        invoiceInfo.invoice_type === 7 ?
                          <div className="table-block">
                            <table className="contr-table invoice-table-style">
                            {(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice?<CtrTableHd theads={['Item', 'Description', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')','JCT Rate','JCT Amount ']} />:
                              titanInstance?<CtrTableHd theads={['Item', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />:
                              <CtrTableHd theads={['Item', 'Description', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />}
                              <tbody>
                                <InsuranceInvoiceItem
                                  showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                  type="view"
                                  invoice_item={invoiceInfo?.invoice_items?.length ? invoiceInfo.invoice_items[0] : []}
                                  invoiceInfo={invoiceInfo}
                                />
                              </tbody>
                            </table>
                          </div> : invoiceInfo.invoice_type === 8 ?
                            <div className="table-block">
                              <table className="contr-table invoice-table-style">
                              {(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice?<CtrTableHd theads={['Item', 'Description', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')','JCT Rate','JCT Amount ']} />:
                                titanInstance?
                                <CtrTableHd theads={['Item', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />:
                                <CtrTableHd theads={['Item', 'Description', 'Insurance Type', 'Insurance Amount', 'Sub Total (' + invoiceInfo.currency + ')']} />}
                                <tbody>
                                  <InsuranceInvoiceItem
                                    showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                    type="view"
                                    invoice_item={invoiceInfo?.invoice_items?.length ? invoiceInfo.invoice_items[0] : []}
                                    invoiceInfo={invoiceInfo}
                                  />
                                </tbody>
                              </table>
                            </div> :
                            <div className="table-block">
                              <table className="contr-table invoice-table-style">
                              {(gaTelesisInstance||Lessor_test) ? 
                                <CtrTableHd theads={['Overdue Amount', 'Description','Penalty %', 'SOFR %', 'Due Date', 'Payment Date', 'Days Overdue', 'Penalty Amount']} />:
                                 titanInstance && invoiceInfo.is_reserve_releted?<CtrTableHd theads={['Over Due Amount', 'FH:FC', 'Due Date', 'Payment Date', 'No Of Days Over Due', '6 Months USD LIBOR  ' + (invoiceInfo.libor_date ? '(' + moment(invoiceInfo.libor_date).format(displayDateFormat) + ')' : ''), 'Additional Rate', 'Total Penal Interest Rate', 'Interest On Over Due Amount']} />:
                                titanInstance?<CtrTableHd theads={['Over Due Amount', 'Due Date', 'Payment Date', 'No Of Days Over Due', '6 Months USD LIBOR  ' + (invoiceInfo.libor_date ? '(' + moment(invoiceInfo.libor_date).format(displayDateFormat) + ')' : ''), 'Additional Rate', 'Total Penal Interest Rate', 'Interest On Over Due Amount']} />:
                                <CtrTableHd theads={['Over Due Amount', 'Description', 'Due Date', 'Payment Date', 'No Of Days Over Due', '6 Months USD LIBOR  ' + (invoiceInfo.libor_date ? '(' + moment(invoiceInfo.libor_date).format(displayDateFormat) + ')' : ''), 'Additional Rate', 'Total Penal Interest Rate', 'Interest On Over Due Amount']} />}
                                <tbody>
                                  {invoiceInfo.invoice_items.map((invoice_item, index) => (
                                  <PenaltyInvoiceItem
                                  showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                    type="view"
                                    invoiceInfo={invoiceInfo}
                                    invoice_item={invoice_item}
                                  />))}
                                </tbody>
                              </table>
                            </div>
                             }
                              {invoiceDate.isBefore(newInvoiveDate) &&(invoiceInfo.invoice_type === 4||invoiceInfo.invoice_type === 5)  ?
                             <div style={{textAlign:"right"}}>
                              { (gaTelesisInstance || Lessor_test)  && invoiceInfo?.jct_invoice?  <>
                          <h5 style={{margin:"10px 0px", color:'#9b9b9b'}} className="para-ui">JCT (10% of Total):
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                          {(invoiceInfo.non_jct_total ? invoiceInfo.non_jct_total : invoiceInfo.sub_total !== undefined && invoiceInfo.sub_total !== null && invoiceInfo.sub_total !== '' ? invoiceInfo.sub_total : invoiceInfo.status == "5" ? diff : total)/10}
                          </NumericLabel>
                        </h5>
                        <h4 className="para">Total:
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                          {parseFloat(invoiceInfo?.total_amount).toFixed(2)}
                          </NumericLabel>
                        </h4>
                         </>:null}
                         </div>:null}
                            </>
                }
              </div>
              {
                invoiceInfo && invoiceInfo.partial_payments && !(invoiceInfo?.is_offset && invoiceInfo?.status == 3  )?
                  <div className="partial-payment-block">
                    <h5>Partial-Payment Details</h5>
                    <div className="table-block">
                      <table className="contr-table partial-payment-table-style">
                        <CtrTableHd theads={['Description', 'Amount Paid', 'Date of Payment', 'Remaining Amount', 'User', 'Last Updated At']} />
                        <tbody>
                          {invoiceInfo.partial_payments.map((item, index) => (
                            <PartialPaymentsList
                              key={index}
                              value={item}
                              invoiceInfo={invoiceInfo}
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div> : null
              }
              {(invoiceInfo.invoice_type == 1) && titanInstance && invoiceInfo?.utilization_attachments?.length?
                  <UtilsAttachments
                    data={invoiceInfo?.utilization_attachments?.length ? invoiceInfo?.utilization_attachments : []}
                  />
                  : null
                }
              <h5 className="para invoice-heading">Bank Detail {invoiceInfo.invoice_type == 2 ? 'For ' + invoiceInfo.currency + ' Rental Receivable' : ''}</h5>
              <BankingInfo
                type="view"
                invoiceInfo={invoiceInfo}
              />

              {invoiceInfo.invoice_type == 2 && invoiceInfo.children ?
                <div>
                  {invoiceInfo.children.length > 0 ?
                    invoiceInfo.children.map((children, index) =>
                      <div>
                        <div className="charge-description-block ">
                          <div className="table-block">
                            <h5 className="para currency-break">{children.currency} Rental Receivable</h5>
                            <table className="contr-table invoice-table-style">
                              {
                                isJac ?
                                  <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', children.rental_type === 1 ? 'Fixed Rate (' + children.currency + ')' : 'Fixed / Per Unit Rate (' + children.currency + ')', 'Sub Total (' + children.currency + ')']} /> :
                                  (gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice?
                                  <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', children.rental_type === 1 ? 'Fixed Rate (' + children.currency + ')' : 'Fixed / Per Unit Rate (' + children.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + children.currency + ')', 'JCT Rate', 'JCT Amount']} />:
                                  titanInstance?
                                  <CtrTableHd theads={['Item', 'Unit Description', 'No. Of Units', children.rental_type === 1 ? 'Fixed Rate (' + children.currency + ')' : 'Fixed / Per Unit Rate (' + children.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + children.currency + ')']} />:
                                  <CtrTableHd theads={['Item', 'Description', 'Unit Description', 'No. Of Units', children.rental_type === 1 ? 'Fixed Rate (' + children.currency + ')' : 'Fixed / Per Unit Rate (' + children.currency + ')', 'Tax Rate (%)', 'Tax Amount', 'Sub Total (' + children.currency + ')']} />
                              }
                              <tbody>
                                {children.invoice_items.map((value, index) => (
                                  <RentalInvoiceItem
                                    showJCT ={(gaTelesisInstance||Lessor_test) && invoiceInfo?.jct_invoice}
                                    isJac={isJac}
                                    key={index}
                                    type="view"
                                    invoice_item={value}
                                    invoiceInfo={invoiceInfo}
                                    validationArray={[]}
                                  />
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="sub-total-block">
                            <h5 className="para-ui">Billable Amount :
                              <NumericLabel params={showCurrencyFormat(children.currency)}>
                                {children.invoice_items.reduce((total, next) =>
                                  total + next.billable_amount, 0
                                )}
                              </NumericLabel>
                            </h5>
                            {
                              invoiceInfo.status == '5' ?
                                <h5 className="para-ui">Paid Amount :
                                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                    {invoiceInfo.partial_paid_amount}
                                  </NumericLabel>
                                </h5> : null
                            }
                            {
                              isJac ? null :
                                <h5 className="para-ui">Tax :
                                  <NumericLabel params={showCurrencyFormat(children.currency)}>
                                    {children.invoice_items.reduce((total, next) =>
                                      total + parseFloat(parseFloat(next.tax_amount).toFixed(2)) , 0
                                    )}
                                  </NumericLabel>
                                </h5>
                            }
                             { (gaTelesisInstance || Lessor_test)  && invoiceInfo?.jct_invoice?  <>
                          <h5 style={{marginTop:"10px"}} className="para-ui">JCT (10% of Total):
                          <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                          {(invoiceInfo.non_jct_total ? invoiceInfo.non_jct_total :children.invoice_items.reduce((total, next) => total + next.sub_total, 0))/10}
                          </NumericLabel>
                        </h5>
                         </>:null}
                            <h4 className="para">Total:
                              <NumericLabel params={showCurrencyFormat(children.currency)}>
                                {(gaTelesisInstance || Lessor_test)  && invoiceInfo?.jct_invoice ?
                                (invoiceInfo?.total_amount || 0).toFixed(2)
                                :children.invoice_items ? children.invoice_items.reduce((total, next) =>
                                  total + next.sub_total, 0
                                ) : invoiceInfo.sub_total !== undefined && invoiceInfo.sub_total !== null && invoiceInfo.sub_total !== '' ? invoiceInfo.sub_total : 0}
                              </NumericLabel>
                            </h4>
                            <this.TotalOffset invoiceInfo={invoiceInfo}/>
                            <this.GrandTotal invoiceInfo={invoiceInfo}/> 
                          </div>
                        </div>
                        <h5 className="para invoice-heading">Bank Detail {invoiceInfo.invoice_type == 2 ? 'For ' + children.currency + ' Rental Receivable' : ''}</h5>
                        <BankingInfo
                          type="view"
                          invoiceInfo={children}
                        />
                      </div>
                    ) : null
                  }
                </div> : null
              }
            </form>
            <DeleteModal isOpen={this.state.delModal} toggle={() => this.toggleDelModal('')} title={"Change Status"} className="modal-tform-delete-pictures modal-dialog-centered">
              <p style={{ textAlign: 'center', marginBottom: '15px' }}>Are you sure, you want to mark this invoice as {this.state.data && this.state.data.status == 3 ? "'paid' ?" : "'cancelled' ?"}</p>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <button type="button" className="btn btn-danger" onClick={() => { this.toggleDelModal(''); this.props.updateInvStatus(this.state.data, 'view'); }}>Yes</button>
                </li>
                <li className="list-inline-item">
                  <button type="button" className="btn btn-primary" onClick={() => this.toggleDelModal('')}>No</button>
                </li>
              </ul>
            </DeleteModal>
            <DeleteModal isOpen={this.state.deleteInvoice} toggle={() => this.setState({ deleteInvoice: false })} title={"Delete Invoice - '" + invoiceInfo.invoice_number + "'"} className="modal-tform-delete-pictures modal-dialog-centered">
              <p style={{ textAlign: 'center', marginBottom: '15px' }}>Are you sure, you want to delete ?</p>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <button type="button" className="btn btn-danger" onClick={() => { this.setState({ deleteInvoice: false }); this.props.deleteInvoice(invoiceInfo.id) }}>Yes</button>
                </li>
                <li className="list-inline-item">
                  <button type="button" className="btn btn-primary" onClick={() => this.setState({ deleteInvoice: false })}>No</button>
                </li>
              </ul>
            </DeleteModal>
            <DeleteModal isOpen={this.state.syncAgainFlag?.flag} toggle={() => this.setState({ syncAgainFlag: false })} title={" Sync to QB"} className="modal-tform-delete-pictures modal-dialog-centered">
              <p style={{ textAlign: 'center', }}>Are you sure you want to sync the invoice with Quickbooks?</p>
              <p style={{ textAlign: 'center', marginBottom: '25px' }}>Last synced by: {invoiceInfo?.qb_last_sync_by?.name || '--'} {' '}({invoiceInfo?.qb_last_sync_time ? moment(invoiceInfo?.qb_last_sync_time).format('MMM DD, YYYY') : '--'})</p>
              <ul className="list-inline">
                <MuiButton style={{ marginRight: '10px' }} variant='contained' size='small' color='primary' onClick={() => { this.setState({ syncAgainFlag: false }); this.getThirdPartyAppUrl(this.state.syncAgainFlag?.data) }}>
                  Proceed
                </MuiButton>
                <MuiButton color='primary' size='small' onClick={() => this.setState({ syncAgainFlag: false })}>
                  Cancel
                </MuiButton>
              </ul>
            </DeleteModal>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className="invoice-status-modal" >
              <ModalHeader toggle={this.toggle}>Change Invoice Status</ModalHeader>
              <ModalBody>
                {
                  this.state.modal ?
                    <ChangeInvoiceStatus
                      params={this.props.params}
                      invoiceInfo={invoiceInfo}
                      status={invoiceInfo.status}
                      updateInvStatus={this.updateInvStatus}
                      invoiceType={invoiceInfo.invoice_type}
                      invoiceStartDate={startDate}
                      invoiceEndDate={endDate}
                      totalAmount={total}
                      diff={diff}
                    /> : null
                }
              </ModalBody>
            </Modal>
          </div> : <ListLoader />
        }
        <EditSidebar
          title="Share Invoice"
          editSideBar={shareInvoiceCrud.flag}
          toggleEditSideBar={() => this.props.closeShareSidebar({ data: {}, flag: false })}
        >
          {shareInvoiceCrud.flag ?
            <ShareInvoice
              shareInv={shareInvoiceCrud.data}
              shareInvoiceFn={this.props.updateShareInvFn}
              toggleEditSideBar={() => this.props.closeShareSidebar({ data: {}, flag: false })}
              invoiceLoader={invoiceLoader}
            /> : null
          }
        </EditSidebar>

        {
          showStatusTimeLine ?
            <Dialog
              maxWidth='md'
              style={{ height: '600px' }}
              open={true}
              onClose={() => this.setState({ showStatusTimeLine: !showStatusTimeLine })}
              aria-labelledby="scroll-dialog-title"
              className='invoice-timeline-modal'
            >
              <DialogTitle id="scroll-dialog-title">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h5>
                    Invoice Status Timeline
                  </h5>
                  <span style={{ cursor: 'pointer' }}>
                    <Close onClick={() => this.setState({ showStatusTimeLine: !showStatusTimeLine })} />
                  </span>
                </div>
              </DialogTitle>
              <DialogContent dividers={true} style={{ height: '600px' }}>
                <div>
                  <Timeline align="left" >
                    {this.state.statusTimeline.map((item, index) =>
                      <TimelineItem>
                        <TimelineOppositeContent > </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot className={titanInstance && invoiceInfo?.approved_status&& invoiceInfo?.status ===1 ?"User-Approved" :  item.current_status} />
                          {
                            (statusTimeline.length - 1) > index ?
                              <>
                                <TimelineConnector />
                                <span className='arrow-corner-block-div' > {'>'}</span>
                              </>
                              : null}
                        </TimelineSeparator>
                        <TimelineContent>

                          <div style={{ display: "flex", alignItems: 'center' }}>
                            <span
                              className={titanInstance && invoiceInfo?.approved_status && invoiceInfo?.status ===1  ?"User-Approved" :  item.current_status}
                              style={{ padding: '1px 20px', width: 'max-content' }}
                            >
                              {titanInstance && invoiceInfo?.approved_status && invoiceInfo?.status ===1 ? "Appproved" : item.current_status}
                            </span>
                            {
                              item?.status_change_reason ?
                                <Tooltip style={{ maxWidth: '10px' }} title={`Reason: ${item?.status_change_reason ? item?.status_change_reason : '--'}`} arrow placement='right'>
                                  <img style={{ width: '13px', marginLeft: '4px', cursor: 'pointer' }} src={imgStoragePath + "inv_info_icon.png"} alt="info" />
                                </Tooltip>
                                : null
                            }
                          </div>
                          <div style={{ marginTop: '2px' }}> {item.user} ({item.date}) </div></TimelineContent>
                      </TimelineItem>
                    )}
                  </Timeline>
                </div>
              </DialogContent>
            </Dialog>
            : null
        }

        { approverModal ?
            <Dialog maxWidth='md' open={true} aria-labelledby="scroll-dialog-title" className='invoice-timeline-modal' >
              <DialogTitle id="scroll-dialog-title">
                Approval Status Change {titanInstance && invoiceInfo.is_reserve_releted?`(${getStageName(displayStage)})`:null}
              </DialogTitle>
              <DialogContent dividers style={{ minWidth: '600px' }}>
                <Grid container spacing={2}>
                  {approverInfo?.approval_status?.approval_status_code === 3 && approverInfo?.approval_details?.[0]?.status === "approved"||approverInfo?.approval_status?.approval_status_code === 1 || approverInfo?.approval_status?.approval_status_code === 4 && approverInfo?.approval_details?.[0]?.status === "reject" ?
                    <Grid md={12}>
                      <Autocomplete
                        options={this.state.approver}
                        getOptionLabel={(option) => option?.name || ''}
                        // disabled={approverInfo.working_group_id}
                        value={ this.state.approver.find( (opt) => opt.id === this.state.formData.working_group_id )|| titanInstance && !approverInfo?.approval_status?.working_group_id ? defaultApprover:null || null }
                        onChange={(e, value) => this.updateApprover('working_group_id', value)}
                        onFocus={() => this.updateErrorField('working_group_id', '')}
                        disabled={!!loadingButton|| defaultApprover}
                        renderInput={params => <TextField disabled={!!loadingButton} required error={error.working_group_id ? true : false} helperText={error.working_group_id || ''}   {...params} label="Approver" margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                      />
                    </Grid> : null}
                    {/* {titanInstance  && loadingButton==="reject"  ?
                    <Grid md={12}>
                      <Autocomplete
                        options={this.state.approver}
                        getOptionLabel={(option) => option?.name || ''}
                        // disabled={approverInfo.working_group_id}
                        value={ this.state.approver.find( (opt) => opt.id === this.state.formData.working_group_id ) || null }
                        onChange={(e, value) => this.updateApprover('working_group_id', value)}
                        onFocus={() => this.updateErrorField('working_group_id', '')}
                        disabled={!!loadingButton}
                        renderInput={params => <TextField disabled={!!loadingButton} required error={error.working_group_id ? true : false} helperText={error.working_group_id || ''}   {...params} label="Approver" margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                      />
                    </Grid> : null} */}
                  {(approverInfo?.approval_status?.approval_status_code === 2) ?
                    <Grid md={12}>
                      <TextField
                        label={`Reason`}
                        id="remark"
                        fullWidth
                        multiline
                        rows={3}
                        error={error.remark ? true : false}
                        helperText={error.remark || ''}
                        onFocus={() => this.updateErrorField('remark', '')}
                        margin="normal"
                        value={this.state.formData.remark}
                        variant='outlined'
                        InputLabelProps={{ shrink: true }}
                        onChange={(e, value) => this.updateApprover('remark', e.target.value)}
                        disabled={!!loadingButton}
                      />
                    </Grid> : null}
                {titanInstance && (approverInfo?.approval_status?.approval_status_code === 2 && invoiceInfo.invoice_type===1||approverInfo?.approval_status?.approval_status_code === 2 && invoiceInfo.parent_invoice_type===1||approverInfo?.approval_status?.approval_status_code === 2 && invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) ?
                  <Grid md={12}>
                    <DropzoneArea
                      filesLimit={5}
                      acceptedFiles={['.xls', '.csv', '.xlsx', '.docx', '.pdf', '.jpg', '.jpeg', '.png']}
                      showPreviewsInDropzone={false}
                      showPreviews={true}
                      useChipsForPreview
                      dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop or Click to Upload</p>}                      
                      dropzoneClass="drag-drop-cnt"
                      maxWidth="sm"
                      maxFileSize={104857600}
                      showAlerts={['error', 'info']}
                      onChange={(files) => !loadingButton && this.setState({ attatchedDoc: files })}
                      alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                     />
                    <h6 style={{ marginTop: '5px', fontSize: '11px' }}>
                      <b>Note:</b>Only pdf, docx, csv, xls, xlsx, jpg, jpeg and png files are supported.
                      <br/>
                      Maximun File size is 100MB
                    </h6>  
                     { loadingButton && ( <div style={{ position:'absolute', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(255,255,255,0.6)', zIndex:10, cursor:'not‑allowed' }} /> )}
                  </Grid> : null}
                {next_stage_working_group_id === null && this.state.showNextApprover && approverInfo?.approval_status?.current_stage !== 3||next_stage_working_group_id === null && this.state.prevApprover && approverInfo?.approval_status?.current_stage !== 1 ?
                    <Grid md={12}>
                      <Autocomplete
                        options={this.state.approver}
                        getOptionLabel={(option) => option?.name || ''}
                        value={ this.state.approver.find( (opt) => opt.id === this.state.formData.next_stage_working_group_id?.id ) || null }
                        onChange={(e, value) => this.updateApprover('next_stage_working_group_id', value)}
                        onFocus={() => this.updateErrorField('next_stage_working_group_id', '')}
                        disabled={!!loadingButton}
                        renderInput={params => <TextField disabled={!!loadingButton} error={error.next_stage_working_group_id ? true : false} helperText={error.next_stage_working_group_id || ''}   {...params} label={this.state.prevApprover?"Select Previous Approver":"Select Next Approver"} margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                      />
                    </Grid> : null}
                </Grid>
              </DialogContent>
              <DialogActions dividers style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                {approverInfo?.approval_status?.approval_status_code === 2 ? (
                  <div>
                    <MuiButton color="primary" variant="contained" size="small" disabled={!!loadingButton} onClick={() => {this.updateApprovalStatus(3, false ,'approve');this.setState({ showNextApprover:titanInstance && (invoiceInfo.invoice_type===1 || invoiceInfo.parent_invoice_type===1 || invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) ? true :false });}} > {loadingButton === 'approve' && approverLoader ?<CircularProgress size={20}/> : 'Approve' }</MuiButton>
                    {titanInstance ? null : invoiceInfo.status ===1 ?<MuiButton color="primary" variant="contained" size="small" disabled={!!loadingButton||((titanInstance&&invoiceInfo?.invoice_type===1||titanInstance&&invoiceInfo?.parent_invoice_type === 1||titanInstance&&invoiceInfo?.is_reserve_releted)?approverInfo.approval_status.current_stage !== 3:null)} onClick={() => this.updateApprovalStatus(3, true, 'approveSend' )} style={{ marginLeft: '5px' }} >{loadingButton === 'approveSend' && approverLoader ?<CircularProgress size={20}/> : 'Approve & Send'} </MuiButton>:null}
                  </div>
                ) : (
                  <div />
                )}
                <div>
                  <MuiButton style={{ marginRight: '5px' }} disabled={!!loadingButton} color="primary" variant="outlined" size="small" onClick={() => this.setState({ approverModal:!approverModal , error:[], formData:{working_group_id: null,remark:'',next_stage_working_group_id: null,rejected_stage_working_group:null}, showNextApprover:false, prevApprover:false })} >Cancel</MuiButton>
                  {(approverInfo?.approval_status?.approval_status_code === 4 && approverInfo?.approval_details?.[0]?.status==='reject' || approverInfo?.approval_status?.approval_status_code === 4||approverInfo?.approval_status?.approval_status_code === 3 && approverInfo?.approval_details?.[0]?.status==='approved'||approverInfo?.approval_status?.approval_status_code === 1) && (<MuiButton disabled={!!loadingButton} color="primary" variant="contained" size="small" onClick={() => this.updateApprovalStatus('',false,'sendApproval')} > {loadingButton === 'sendApproval' && approverLoader ?<CircularProgress size={20}/>:(approverInfo?.approval_status?.approval_status_code === 1||approverInfo?.approval_status?.approval_status_code === 3 && approverInfo?.approval_details?.[0]?.status==='approved' ? 'Send for Approval' : 'Send for Re-Approval')} </MuiButton>)}
                  {approverInfo?.approval_status?.approval_status_code === 2 && (<MuiButton disabled={!!loadingButton|| titanInstance && invoiceInfo.is_reserve_releted && approverInfo.approval_status.current_stage === 1} color="secondary" variant="contained" size="small" onClick={() => {   this.updateApprovalStatus(4, false, 'reject');this.setState({ prevApprover:titanInstance && (invoiceInfo.invoice_type===1 || invoiceInfo.parent_invoice_type===1 || invoiceInfo.invoice_type === 5 && invoiceInfo.is_reserve_releted === true) ? true :false })}} style={{ marginLeft: '5px' }} >{loadingButton === 'reject' && approverLoader && !this.state.isRejectSave ?<CircularProgress size={20}/>: 'Reject'} </MuiButton>)}
                </div>
              </DialogActions>
            </Dialog>: null}
        {this.state.attachmentModalOpen ?
        <Dialog open={this.state.attachmentModalOpen} maxWidth="md" fullWidth >
          <DialogTitle>Attachments for {getStageName(this.state.selectedStage)}</DialogTitle>
          <DialogContent style={{padding:'10px'}} dividers>
              {(() => {
                const stageAttachments = this.state.attachments[this.state.selectedStage] || [];
                const latestAttachment = stageAttachments.length ? stageAttachments.reduce((latest, current) => new Date(current.created_at) > new Date(latest.created_at) ? current : latest) : null;
                const remarkText = latestAttachment?.remark;
                const statusText = latestAttachment?.status || '';
                const statusLabel = statusText.toLowerCase() === 'approved' ? 'Approved Reason' : statusText.toLowerCase() === 'rejected' ? 'Rejected Reason' : 'Reason';
                 if (!remarkText || remarkText === '--') return null;                
                 return (
                  remarkText.length ? (
                  <div style={{ display:'flex', alignItems:'center', marginBottom: '10px', padding: '5px', backgroundColor: statusText.toLowerCase() === 'approved' ? 'rgb(223 226 233)' : statusText.toLowerCase() === 'rejected' ? 'rgb(223 226 233)' : 'rgb(223 226 233)', borderRadius: '4px', border: '1px solid #ddd', }} >
                    <strong>{statusLabel}:</strong><p style={{fontSize:'16px'}}> {remarkText}</p>
                  </div>):null
                );
              })()}
            <TableContainer component={Paper} style={{ maxHeight: window.innerHeight - 240 + 'px', overflow: "auto" }}>
              <Table className='mui-table-format' stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Attachment(s)</TableCell>
                    <TableCell>Created By</TableCell>
                    <TableCell>Created Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell><div style={{ float: 'right' }}>Action(s)</div></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(this.state.attachments[this.state.selectedStage] || []).map((item) => (
                    <TableRow key={item.id}>
                      <TableCell><div style={{width:'250px'}}>{item?.name}</div></TableCell>
                      <TableCell>{item?.uploaded_by?.name || '-'}</TableCell>
                      <TableCell>{item?.created_at ? moment.utc(item?.created_at).local().format(displayDateTimeFormatShort) : '-'}</TableCell>
                      <TableCell>{item?.status||"--"}</TableCell>
                      <TableCell>
                        <ul className="list-inline" style={{ float: 'right' }}>
                          <li className="list-inline-item hover-inline" onClick={() => downloadFile(item)}>
                            <Tooltip title='Download' arrow><GetAppIcon color="primary" fontSize="small" /></Tooltip>
                          </li>

                          <li className="list-inline-item hover-inline" onClick={() => this.handleViewClick(item)}>
                            <Tooltip title='View' arrow><VisibilityIcon style={{ cursor: 'pointer' }} color='primary' fontSize='small' /></Tooltip>
                          </li> 
                        </ul>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
              {this.state.attachments[this.state.selectedStage]?.length === 0 && (
                <Paper>
                  <EmptyCollection title='No records found' />
                </Paper>
              )}
          </DialogContent>
          <DialogActions>
            <MuiButton onClick={() => this.setState({ attachmentModalOpen: false })} color="primary" size='small' variant="outlined" > Close </MuiButton>
          </DialogActions>
        </Dialog> : null }
        {this.state.timelineModal ? <ApprovalTimelineModal  toggleModalFn={() => this.setState({ timelineModal: false })} approvalData={this.state.approverInfo.approval_details} /> :null}
        {this.state.rejectedModal ? <RejectedStatusChangeModal  loadingButton={loadingButton} approverLoader={approverLoader} toggleModalFn={() => this.setState({ rejectedModal: false, isRejectSave : false })} workingGroupConfig={approverInfo?.working_group_config} updateApprover={this.updateApprover} updateErrorField={this.updateErrorField} error={this.state.error} onRejectSave={this.onRejectSave}   /> :null}
        {this.state.filePreviewModal ?
          <FilePreview
            downloadFile={downloadFile}
            toggleModalFn={() => this.setState({ filePreviewModal: false })}
            fileInfo={this.state.selectedFile}
          /> : null}
          {/* {this.state.approverLoader ? <PageLoader/>:null} */}
      </div>
    )
  }
}
const mapStateToProps = state => ({
  contractSummaryLoader: state.sharedReducers.contractSummaryLoader,
  invoiceInfo: state.InvoiceReducer.invoiceView,
  ctrShortInfo: state.ContractListReducer.ctrShortInfo,
  invoiceLoader: state.InvoiceReducer.invoiceLoader,
  shareInvoiceCrud: state.InvoiceReducer.shareInvoiceCrud,
  invoiceExportLoader: state.InvoiceReducer.invoiceExportLoader,
  contractInfo: state.ContrHdlineReducer.contrHdlineInfo,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchContractInfo: () => dispatch(contrHdlineInfoAc(ownProps.params)),
    fetchAssetInfo: () => dispatch(InvoiceAssetViewAc(ownProps.params)),
    fetchInvoiceView: () => dispatch(invoiceViewAc(ownProps.params)),
    deleteInvoice: (invoiceId) => dispatch(deleteInvoiceViewAc(ownProps.params, invoiceId)),
    updateInvStatus: (data, type) => dispatch(changeInvoiceStatusAc(ownProps.params, data, ownProps.params.contract_slug, ownProps.params.id, type)),
    exportInvoice: (ctrShortInfo, invoiceNumber, fileType, invoiceInfo) => dispatch(detailInvExportAc(ownProps.params, ctrShortInfo, invoiceNumber, fileType, invoiceInfo)),
    getShareInvoiceInfo: () => dispatch(getShareInvoiceInfoAc(ownProps.params)),
    updateShareInvFn: (data) => dispatch(updateShareInvFnAc(ownProps.params, data)),
    closeShareSidebar: (data) => dispatch({
      type: INVOICE_SHARE,
      payload: data
    }),
    exportContract: (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
    // updateQbSyncState: () => dispatch({type: 'QB_SYNC_STATE',payload:'invoice_to_qb'})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(ViewInvoiceForm, ['contracts', 'invoices', 'R']));
